import type { Template } from '@/app/dashboard/templates/components/types/template';

export function templateOwnsPromotionPlacement(template?: Template | null) {
  const pagedFlip = template?.pagedFlip;
  const pagedNodes = template?.pagedNodes;
  const pageSlots = Array.isArray(pagedNodes)
    ? pagedNodes.flatMap((node) => {
        const slot = node?.props?.pageSlot;
        return Array.isArray(slot) ? slot : slot ? [slot] : [];
      })
    : Object.keys(pagedNodes || {});

  return Boolean(
    (pagedFlip as { promotionPages?: { enabled?: boolean } } | undefined)?.promotionPages?.enabled ||
      pageSlots.includes('promotion-showcase'),
  );
}
